import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'
import { useApiErrorHandler } from '../../../useApiErrorHandler'

interface DeleteKeepContactParams {
  id: string
}

const deleteKeepContact = async ({ id }: DeleteKeepContactParams): Promise<void> => {
  await api.delete(`/keep-contact/${id}`)
}

export const useDeleteKeepContact = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()
  const handleApiError = useApiErrorHandler()

  return useMutation<void, Error, DeleteKeepContactParams>({
    mutationFn: deleteKeepContact,
    onSuccess: async (_, variables) => {
      showSuccessToast(t('toast.success'), t('toast.reminderDeleted'))
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['keep-contacts'] }),
        queryClient.invalidateQueries({ queryKey: ['keep-contact', variables.id] }),
      ])
    },
    // A refused deletion says so instead of failing in silence.
    onError: handleApiError,
  })
}

